import { render, staticRenderFns } from "./chatPerson.vue?vue&type=template&id=532484c1&scoped=true&"
import script from "./chatPerson.vue?vue&type=script&lang=js&"
export * from "./chatPerson.vue?vue&type=script&lang=js&"
import style0 from "./chatPerson.vue?vue&type=style&index=0&id=532484c1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532484c1",
  null
  
)

export default component.exports